export * from './app-sidebar-nav.component';



// WEBPACK FOOTER //
// /Users/adminuser/Documents/pentagon/pentagon-admin/src/app/components/app-sidebar-nav/index.ts